import type { UserNotification } from 'services/notification';

/**
 * Resolve in-app navigation path for a user notification.
 * Falls back to the notifications list (optionally highlighting the row) when
 * the payload is incomplete or of an unknown type.
 */
export const getNotificationNavigationPath = (
  item: Pick<UserNotification, 'id' | 'type' | 'data'>
): string => {
  const data = item.data || {};

  if (item.type === 'ADHOC_ISSUE' && data.issueId) {
    return `/issues?tab=adHocIssues&adHocIssueId=${data.issueId}`;
  }

  if (item.type === 'ROOM_ISSUE' && data.issueId && data.submitId) {
    return `/issues?tab=roomIssues&roomIssueId=${data.issueId}&submitId=${data.submitId}`;
  }

  if (item.type === 'ASSET_ISSUE' && data.issueId && data.submitId && data.submittedAssetId) {
    return `/issues?tab=assetIssues&assetIssueId=${data.issueId}&submitId=${data.submitId}&submittedAssetId=${data.submittedAssetId}`;
  }

  if (item.type === 'MAINTENANCE_ISSUE' && data.issueId) {
    return `/issues?tab=maintenanceIssues&maintenanceIssueId=${data.issueId}`;
  }

  console.warn('[notificationNavigation] Unhandled notification, falling back to list.', {
    type: item.type,
    data
  });

  return `/notifications?highlightNotificationId=${item.id}`;
};
